"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iam = void 0;
const extendedIam_1 = require("./extendedIam");
const core_1 = require("@smash-sdk/core");
const errors_1 = require("./errors");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/ListGroupRoles/ListGroupRoles"), exports);
__exportStar(require("./types/ListGroupTeams/ListGroupTeams"), exports);
__exportStar(require("./types/ListGroupUsers/ListGroupUsers"), exports);
__exportStar(require("./types/ListGroups/ListGroups"), exports);
__exportStar(require("./types/ListGroupsSCIM/ListGroupsSCIM"), exports);
__exportStar(require("./types/ListPolicies/ListPolicies"), exports);
__exportStar(require("./types/ListProviders/ListProviders"), exports);
__exportStar(require("./types/ListRoles/ListRoles"), exports);
__exportStar(require("./types/ListTeamGroupRoles/ListTeamGroupRoles"), exports);
__exportStar(require("./types/ListTeamGroupUsers/ListTeamGroupUsers"), exports);
__exportStar(require("./types/ListTeamGroups/ListTeamGroups"), exports);
__exportStar(require("./types/ListTeamRoles/ListTeamRoles"), exports);
__exportStar(require("./types/ListTeamUserGroups/ListTeamUserGroups"), exports);
__exportStar(require("./types/ListTeamUserRoles/ListTeamUserRoles"), exports);
__exportStar(require("./types/ListTeamUsers/ListTeamUsers"), exports);
__exportStar(require("./types/ListTeams/ListTeams"), exports);
__exportStar(require("./types/ListUserGroups/ListUserGroups"), exports);
__exportStar(require("./types/ListUserGroupsRoles/ListUserGroupsRoles"), exports);
__exportStar(require("./types/ListUserGroupsTeams/ListUserGroupsTeams"), exports);
__exportStar(require("./types/ListUserRoles/ListUserRoles"), exports);
__exportStar(require("./types/ListUserTeams/ListUserTeams"), exports);
__exportStar(require("./types/ListUsers/ListUsers"), exports);
__exportStar(require("./types/ListUsersSCIM/ListUsersSCIM"), exports);
__exportStar(require("./types/PatchGroupSCIM/PatchGroupSCIM"), exports);
__exportStar(require("./types/PatchUserSCIM/PatchUserSCIM"), exports);
__exportStar(require("./types/RenewToken/RenewToken"), exports);
__exportStar(require("./types/ResetPassword/ResetPassword"), exports);
__exportStar(require("./types/RotateKey/RotateKey"), exports);
__exportStar(require("./types/RotateUserKey/RotateUserKey"), exports);
__exportStar(require("./types/SamlSignon/SamlSignon"), exports);
__exportStar(require("./types/SsoSignin/SsoSignin"), exports);
__exportStar(require("./types/UpdateAccount/UpdateAccount"), exports);
__exportStar(require("./types/UpdateGroup/UpdateGroup"), exports);
__exportStar(require("./types/UpdateGroupSCIM/UpdateGroupSCIM"), exports);
__exportStar(require("./types/UpdateManagedPolicy/UpdateManagedPolicy"), exports);
__exportStar(require("./types/UpdatePassword/UpdatePassword"), exports);
__exportStar(require("./types/UpdatePolicy/UpdatePolicy"), exports);
__exportStar(require("./types/UpdateProvider/UpdateProvider"), exports);
__exportStar(require("./types/UpdateRole/UpdateRole"), exports);
__exportStar(require("./types/UpdateTeam/UpdateTeam"), exports);
__exportStar(require("./types/UpdateTeamGroup/UpdateTeamGroup"), exports);
__exportStar(require("./types/UpdateTeamUser/UpdateTeamUser"), exports);
__exportStar(require("./types/UpdateUser/UpdateUser"), exports);
__exportStar(require("./types/UpdateUserSCIM/UpdateUserSCIM"), exports);
__exportStar(require("./types/DeleteGroup/DeleteGroup"), exports);
__exportStar(require("./types/DeleteGroupSCIM/DeleteGroupSCIM"), exports);
__exportStar(require("./types/DeletePolicy/DeletePolicy"), exports);
__exportStar(require("./types/DeleteProvider/DeleteProvider"), exports);
__exportStar(require("./types/DeleteRole/DeleteRole"), exports);
__exportStar(require("./types/DeleteTeam/DeleteTeam"), exports);
__exportStar(require("./types/DeleteUser/DeleteUser"), exports);
__exportStar(require("./types/DeleteUserSCIM/DeleteUserSCIM"), exports);
__exportStar(require("./types/DetachGroupRole/DetachGroupRole"), exports);
__exportStar(require("./types/DetachGroupUser/DetachGroupUser"), exports);
__exportStar(require("./types/DetachRolePolicy/DetachRolePolicy"), exports);
__exportStar(require("./types/DetachTeamGroup/DetachTeamGroup"), exports);
__exportStar(require("./types/DetachTeamGroupRole/DetachTeamGroupRole"), exports);
__exportStar(require("./types/DetachTeamGroupUser/DetachTeamGroupUser"), exports);
__exportStar(require("./types/DetachTeamRole/DetachTeamRole"), exports);
__exportStar(require("./types/DetachTeamUser/DetachTeamUser"), exports);
__exportStar(require("./types/DetachTeamUserRole/DetachTeamUserRole"), exports);
__exportStar(require("./types/DetachUserRole/DetachUserRole"), exports);
__exportStar(require("./types/ForgotPassword/ForgotPassword"), exports);
__exportStar(require("./types/GetAccount/GetAccount"), exports);
__exportStar(require("./types/GetGroup/GetGroup"), exports);
__exportStar(require("./types/GetGroupSCIM/GetGroupSCIM"), exports);
__exportStar(require("./types/GetPolicy/GetPolicy"), exports);
__exportStar(require("./types/GetProvider/GetProvider"), exports);
__exportStar(require("./types/GetResourceTypes/GetResourceTypes"), exports);
__exportStar(require("./types/GetRole/GetRole"), exports);
__exportStar(require("./types/GetSchemas/GetSchemas"), exports);
__exportStar(require("./types/GetServiceProviderConfig/GetServiceProviderConfig"), exports);
__exportStar(require("./types/GetSigninConfiguration/GetSigninConfiguration"), exports);
__exportStar(require("./types/GetTeam/GetTeam"), exports);
__exportStar(require("./types/GetTeamGroup/GetTeamGroup"), exports);
__exportStar(require("./types/GetTeamUser/GetTeamUser"), exports);
__exportStar(require("./types/GetUser/GetUser"), exports);
__exportStar(require("./types/GetUserSCIM/GetUserSCIM"), exports);
__exportStar(require("./types/InviteTeamUser/InviteTeamUser"), exports);
__exportStar(require("./types/InviteUser/InviteUser"), exports);
__exportStar(require("./types/AcceptInvitation/AcceptInvitation"), exports);
__exportStar(require("./types/AcceptUserInvitation/AcceptUserInvitation"), exports);
__exportStar(require("./types/AttachGroupRole/AttachGroupRole"), exports);
__exportStar(require("./types/AttachGroupUser/AttachGroupUser"), exports);
__exportStar(require("./types/AttachRolePolicy/AttachRolePolicy"), exports);
__exportStar(require("./types/AttachTeamGroup/AttachTeamGroup"), exports);
__exportStar(require("./types/AttachTeamGroupRole/AttachTeamGroupRole"), exports);
__exportStar(require("./types/AttachTeamGroupUser/AttachTeamGroupUser"), exports);
__exportStar(require("./types/AttachTeamRole/AttachTeamRole"), exports);
__exportStar(require("./types/AttachTeamUser/AttachTeamUser"), exports);
__exportStar(require("./types/AttachTeamUserRole/AttachTeamUserRole"), exports);
__exportStar(require("./types/AttachUserRole/AttachUserRole"), exports);
__exportStar(require("./types/ChangePassword/ChangePassword"), exports);
__exportStar(require("./types/CreateAccount/CreateAccount"), exports);
__exportStar(require("./types/CreateGroup/CreateGroup"), exports);
__exportStar(require("./types/CreateGroupSCIM/CreateGroupSCIM"), exports);
__exportStar(require("./types/CreatePolicy/CreatePolicy"), exports);
__exportStar(require("./types/CreateProvider/CreateProvider"), exports);
__exportStar(require("./types/CreateRole/CreateRole"), exports);
__exportStar(require("./types/CreateTeam/CreateTeam"), exports);
__exportStar(require("./types/CreateToken/CreateToken"), exports);
__exportStar(require("./types/CreateUser/CreateUser"), exports);
__exportStar(require("./types/CreateUserSCIM/CreateUserSCIM"), exports);
__exportStar(require("./types/CreateUserToken/CreateUserToken"), exports);
__exportStar(require("./types/DeleteAccount/DeleteAccount"), exports);
__exportStar(require("./types/DecodeToken/DecodeToken"), exports);
const endpoints = {
    "ca-central-1": "https://iam.ca-central-1.fromsmash.co",
    "eu-central-1": "https://iam.eu-central-1.fromsmash.co",
    "eu-west-1": "https://iam.eu-west-1.fromsmash.co",
    "eu-west-2": "https://iam.eu-west-2.fromsmash.co",
    "eu-west-3": "https://iam.eu-west-3.fromsmash.co",
    "us-east-1": "https://iam.us-east-1.fromsmash.co",
    "us-east-2": "https://iam.us-east-2.fromsmash.co",
    "us-west-1": "https://iam.us-west-1.fromsmash.co",
    "us-west-2": "https://iam.us-west-2.fromsmash.co",
};
core_1.config.setHosts("iam", endpoints, false);
class Iam extends extendedIam_1.ExtendedIam {
    constructor(params = {}) {
        super(Object.assign(Object.assign({ service: "iam" }, params), { type: "regional", userAgent: "@smash-sdk/iam@1.0.0-alpha.7" }));
        this.errors = errors_1.errors;
    }
    listGroupRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listGroupTeams(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listGroupUsers(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listGroups() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listGroupsSCIM(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        startIndex: params["startIndex"],
                        count: params["count"],
                        filter: params["filter"],
                        excludedAttributes: params["excludedAttributes"],
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupsSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listPolicies() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/policies",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListPoliciesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listProviders() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/providers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListProvidersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listRoles() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamGroupRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamGroupUsers(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamGroups(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamUserGroups(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamUserRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeamUsers(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listTeams() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUserGroups(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUserGroupsRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUserGroupsTeams(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUserRoles(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUserTeams(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUsers() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    listUsersSCIM(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        startIndex: params["startIndex"],
                        count: params["count"],
                        filter: params["filter"],
                        excludedAttributes: params["excludedAttributes"],
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUsersSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    patchGroupSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PATCH",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        Operations: params["Operations"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.PatchGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    patchUserSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PATCH",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        Operations: params["Operations"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.PatchUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    renewToken(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        refreshToken: params["refreshToken"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RenewTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    resetPassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/reset",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    rotateKey() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/key/rotate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RotateKeyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    rotateUserKey(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/key/rotate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RotateUserKeyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    samlSignon(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/saml/signon",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        SAMLResponse: params["SAMLResponse"],
                        RelayState: params["RelayState"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SamlSignonError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    ssoSignin(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/sso/signin",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SsoSigninError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateAccount(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        firstName: params["firstName"],
                        lastName: params["lastName"],
                        language: params["language"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateGroupSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        displayName: params["displayName"],
                        groupType: params["groupType"],
                        members: params["members"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateManagedPolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/managedPolicy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateManagedPolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updatePassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/update",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        currentPassword: params["currentPassword"],
                        newPassword: params["newPassword"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdatePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updatePolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdatePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateProvider(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/provider/:name",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        idpUrl: params["idpUrl"],
                        certificate: params["certificate"],
                        status: params["status"],
                        audienceUri: params["audienceUri"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateTeam(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        config: params["config"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateTeamGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateTeamUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    updateUserSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        userName: params["userName"],
                        name: params["name"],
                        emails: params["emails"],
                        displayName: params["displayName"],
                        locale: params["locale"],
                        active: params["active"],
                        groups: params["groups"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteGroupSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deletePolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeletePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteProvider(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/provider/:issuer",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        issuer: params["issuer"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteTeam(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteUserSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachGroupRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachGroupUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachRolePolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId/policy/:policyId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachRolePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamGroupRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamGroupUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachTeamUserRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    detachUserRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    forgotPassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/forgot",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ForgotPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getAccount() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getGroupSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getPolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetPolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getProvider(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/provider/:name",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getResourceTypes() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/ResourceTypes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetResourceTypesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getSchemas() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Schemas",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSchemasError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getServiceProviderConfig() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/ServiceProviderConfig",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetServiceProviderConfigError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getSigninConfiguration(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/signin/configuration/:username",
                    headers: {},
                    pathParameters: {
                        username: params["username"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSigninConfigurationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getTeam(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getTeamGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getTeamUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    getUserSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    inviteTeamUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/invite",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InviteTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    inviteUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/invite",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InviteUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    acceptInvitation(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/invitation/accept",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        secret: params["secret"],
                        account: params["account"],
                        user: params["user"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AcceptInvitationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    acceptUserInvitation(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/invitation/accept",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        secret: params["secret"],
                        account: params["account"],
                        user: params["user"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AcceptUserInvitationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachGroupRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachGroupUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachRolePolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId/policy/:policyId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachRolePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamGroupRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamGroupUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamUser(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachTeamUserRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    attachUserRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    changePassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/change",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ChangePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createAccount(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/group",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createGroupSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/Groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        externalId: params["externalId"],
                        displayName: params["displayName"],
                        meta: params["meta"],
                        members: params["members"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createPolicy(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/policy",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreatePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createProvider(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/provider",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        issuer: params["issuer"],
                        name: params["name"],
                        type: params["type"],
                        idpUrl: params["idpUrl"],
                        certificate: params["certificate"],
                        metadata: params["metadata"],
                        status: params["status"],
                        audienceUri: params["audienceUri"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createRole(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/role",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createTeam(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/team",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        domain: params["domain"],
                        config: params["config"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createToken(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createUser(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createUserSCIM(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/Users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        externalId: params["externalId"],
                        userName: params["userName"],
                        active: params["active"],
                        emails: params["emails"],
                        meta: params["meta"],
                        name: params["name"],
                        displayName: params["displayName"],
                        locale: params["locale"],
                        groups: params["groups"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    createUserToken(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user/:userId/token",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        scope: params["scope"],
                        ip: params["ip"],
                        tokenDuration: params["tokenDuration"],
                        refreshTokenDuration: params["refreshTokenDuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
    deleteAccount() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_1.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_1.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_1.SDKError(error));
                    }
                }
                else {
                    reject(new core_1.SDKError(error));
                }
            }
        }));
    }
}
exports.Iam = Iam;
Iam.errors = errors_1.errors;
